import { LMMediaCategory } from "features/Dealers/Listings/Images/state/types";

export const NOT_DEFAULT_CANDIDATES = ["COVER", "PROFILE"]

export const getDefaultCategory = (categories: LMMediaCategory[]) => {
    for (const category of categories) {
        if (!NOT_DEFAULT_CANDIDATES.includes(category.name)) {
            return category;
        }
    }
    throw "Category not found"
}

export const IMAGE_PICKER_TRIGGER = {
    NONE: "NONE",
    COVER: "COVER",
    FACEBOOKPHOTO: "FACEBOOKPHOTO",
    IMAGE: "IMAGE"
}